/* Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential */

import { Inject, Injectable } from "@angular/core";
import { Observable, timer } from "rxjs";
import { DOCUMENT } from "@angular/common";
import { filter, map, tap } from "rxjs/operators";

/**
 * Service used to provide information if the App is currently visible.
 * Not visible/ hidden means that there is another opened tab in focus.
 */
// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class AppVisibilityService {
    private static REALTIME_UPDATE_INTERVAL: number = 5 * 1000;

    public visibleChanged: Observable<boolean> = Observable.create(observer => {
        let isVisible: boolean = !this.document.hidden;
        observer.next(isVisible);
        return timer(AppVisibilityService.REALTIME_UPDATE_INTERVAL,
                     AppVisibilityService.REALTIME_UPDATE_INTERVAL)
            .pipe(map((unused) => !this.document.hidden),
                  filter(next => next != isVisible),
                  tap(next => isVisible = next))
            .subscribe(observer);
    });

    constructor(@Inject(DOCUMENT) private document: Document) {
    }
}
